export const transactionTypeTranslator = types => {
  let newTypes = [];
  types.map(type => {
    switch (type) {
      case 'parking':
        newTypes.push('停車');
        break;
      case 'refueling':
        newTypes.push('加油');
        break;
      case 'on_street_parking':
        newTypes.push('路邊停車');
        break;
      case 'lease':
        newTypes.push('月租');
        break;
      case 'pay_taipei':
        newTypes.push('台北市停車路停之外代收');
        break;
      case 'vehicle_maintenance':
        newTypes.push('汽車美容');
        break;
      case 'insurance':
        newTypes.push('保險');
        break;
      case 'wash_car':
        newTypes.push('洗車');
        break;
      case 'charging':
        newTypes.push('充電');
        break;
      case 'rental_car':
        newTypes.push('租車');
        break;
      case 'vehicle_repair':
        newTypes.push('維修保養');
        break;
      case 'refuleing_payment':
        newTypes.push('加油連鎖店');
        break;
      case 'easy_wallet_refund':
        newTypes.push('悠遊付退款');
        break;
      case 'miscellaneous':
        newTypes.push('其他代收');
        break;
      default:
        break;
    }

    return '';
  });
  return newTypes;
};
